export const MenuItems = [
  {
    name: 'dam',
    title: 'DAM',
    children: [
      {
        title: 'Product images',
        name: 'product-images',
        icon: 'ion-image',
        route: ['/', 'dam', 'product-images'],
        children: [
          {
            title: 'Master image',
            name: 'master-image',
            route: ['/', 'dam', 'master-image']
          }
        ]
      },
      {
        title: 'Contents',
        name: 'contents',
        icon: 'ion-link',
        route: ['/', 'dam', 'contents'],
        children: [
          {
            title: '3D Management',
            name: '3d-management',
            icon: 'ion-document-text',
            route: ['/', 'dam', '3d-management']
          }
        ]
      },
      {
        title: 'POP Images',
        name: 'pop-images',
        icon: 'ion-images',
        route: ['/', 'dam', 'pop-images']
      },
      {
        title: 'Log Activities Product Images',
        name: 'log-activities-product-images',
        icon: 'ion-link',
        route: ['/', 'dam', 'log-activities-product-images']
      },
      {
        title: 'Log Activities Contents',
        name: 'log-activities-contents',
        icon: 'ion-link',
        route: ['/', 'dam', 'log-activities-contents']
      }
    ]
  }
]
